import React, { createContext, useContext } from "react";
import { useData } from "./DataContext";
import ROLES from "../routes/Roles";
import { accessibleFeatures } from "../utils/rolesAccessMapping";

const ProfilesContext = createContext({ checkAccess: () => {} });

export const ProfilesProvider = ({ children }) => {
  const { userData } = useData();
  const userRoles = userData?.user_roles || [];
  const checkAccess = (allowedRoles) => {
    return allowedRoles.some((role) => userRoles.includes(role));
  };

  const profiles = {
    isInvoiceAdmin: checkAccess([ROLES.INVOICE_ADMIN]),
    isInvoiceViewer: checkAccess([ROLES.INVOICE_VIEWER]),
    isSuperAdmin: checkAccess([ROLES.SUPER_ADMIN]),
    isGuestUser: checkAccess([ROLES.GUEST_EMPLOYEE]),
    isTimesheetEmployee: checkAccess([ROLES.TIMESHEET_EMPLOYEE]),
    isPmoUser: checkAccess([ROLES.PMO_USER]),
    isHrAndProjectManager:
      checkAccess([ROLES.HR_MANAGER]) && checkAccess([ROLES.TIMESHEET_MANAGER]),

    isAdminAndProjectManager:
      checkAccess([ROLES.TIMESHEET_MANAGER]) &&
      checkAccess([ROLES.TIMESHEET_ADMIN]),

    isTimesheetApprover: checkAccess(
      accessibleFeatures.timesheet.getTimesheetApprovalsCount
    ),
    isHrManager: checkAccess(
      accessibleFeatures.timesheet.approveUnplannedTimeoff
    ),
    isTsContractManager: checkAccess(
      accessibleFeatures.timesheet.approveContractTimesheet
    ),
    isTimesheetAdmin: checkAccess(
      accessibleFeatures.timesheet.approveAnyTimesheet
    ),
  };

  return (
    <ProfilesContext.Provider value={{ ...profiles, checkAccess }}>
      {children}
    </ProfilesContext.Provider>
  );
};

export const useProfiles = () => useContext(ProfilesContext);
